import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { get } from 'lodash';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import Button from 'chameleon/ui-stack/ui/base/button';
import { downloadAllAnswerSheets as downloadAllAnswerSheetsAction } from 'legacy/src/actions/paperscorer';
import './index.scss';

const DownloadAllAnswerSheetsButton = ({
  assignmentId,
  assignmentName,
  children,
  className,
  downloadAllAnswerSheets,
  loadingAllAnswerSheets,
  sectionName,
  subjectName,
}) => (
  <div className={`DownloadAllASBtn ${className || ''}`}>
    <Button
      isSecondary
      onClick={() =>
        downloadAllAnswerSheets({
          assignmentId,
          assignmentName,
          subjectName,
          sectionName,
        })
      }
    >
      {children}
    </Button>
    {loadingAllAnswerSheets && (
      <div className="DownloadAllASBtn__loading-spinner-container">
        <LoadingSpinner containerClassName="DownloadAllASBtn__loading-spinner" />
      </div>
    )}
  </div>
);

const mapStateToProps = (state) => ({
  assignmentId: get(state, 'teacherAssignment.assignment.id'),
  assignmentName: get(state, 'teacherAssignment.assignment.title'),
  loadingAllAnswerSheets: get(state, 'paperscorer.loadingAllAnswerSheets'),
  sectionName: get(state, 'teacherAssignment.assignment.section_name'),
  subjectName: get(state, 'subject.data.name'),
});

const mapDispatchToProps = {
  downloadAllAnswerSheets: downloadAllAnswerSheetsAction,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  DownloadAllAnswerSheetsButton,
);
